import { FC } from "react";
import { GenericProps } from "../../../../../types/types";

const PopupBioDesc: FC<GenericProps> = ({ children, className = "" }) => {
  return <p className="text-sm font-medium leading-6 text-white mt-2">{children}</p>;
};

export default PopupBioDesc;
